/** 货主类型 */
export const SELLEROWNERTYPE = {
  /** 统一货主 */
  UNIQUE: 'unique',
  /** 多货主 */
  MULTI: 'multi',
}

export const ALL_KEY = 'all'
export const DEFAULT_FREIGHT_PAYMENT = 'sender_monthly'

export const SOURCE_SYSTEM = 'ONEWAREHOUSE'

export const NO_DECIMALS_COC = ['TWD', 'VND', 'IDR']

/**
 * 最大搜索数量
 */
export const MAX_SEARCH_IDS = 500

export const FEEDBACK_APP_ID = 'ONE02'
